import React from 'react';
import { useNavigate } from 'react-router-dom';
import { ArrowLeftIcon } from 'lucide-react';
import LanguageSwitcher from './LanguageSwitcher';
interface HeaderProps {
  title: string;
  showBackButton?: boolean;
}
const Header = ({
  title,
  showBackButton = false
}: HeaderProps) => {
  const navigate = useNavigate();
  return <header className="bg-[#f9b30f] text-black p-4 flex items-center justify-between shadow-sm" data-id="element-40">
      <div className="flex items-center" data-id="element-41">
        {showBackButton && <button onClick={() => navigate(-1)} className="mr-2 p-1 hover:bg-white/10 rounded-full transition-colors" aria-label="Terug" data-id="element-42">
            <ArrowLeftIcon size={24} data-id="element-43" />
          </button>}
        <div className="flex items-center" data-id="element-44">
          <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/kHbcTFuL12xcnB5vGryAMD/logo.png" alt="Camping Olympia" className="h-8 mr-2" data-id="element-45" />
          <h1 className="text-xl font-bold" data-id="element-46">{title}</h1>
        </div>
      </div>
      <LanguageSwitcher data-id="element-47" />
    </header>;
};
export default Header;